import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { APP_BAR_BLACK_LISTED_PATH } from '../../utilities/constants';
import AppBar from '../AppBar';

const AppBarController: React.FC = () => {
  const location = useLocation();

  const showAppbar = useMemo(() => {
    if (APP_BAR_BLACK_LISTED_PATH.includes(location.pathname)) return false;
    return true;
  }, [location]);

  return <>{showAppbar && <AppBar />}</>;
};

export default AppBarController;
